import fetch from 'isomorphic-fetch'
import ApplicationConf from '../../conf/ApplicationConf'
import { WaitAction } from 'react-aquasys'
import SignInAction from '../../login/actions/SignInAction'
import { ADD_MESSAGE, ERROR, RESET_MESSAGE } from '../constants/resetPasswordConstants'
import i18n from 'simple-react-i18n'

const resetPasswordAction = {

	resetPassword(resultData) {
		return dispatch => {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.user.updatePassword(), {
				method: 'POST',
				headers: {
					Accept: 'application/json'
				},
				body: JSON.stringify({
					licence: 'AQUADB_FRONTEND_BETA',
					data: resultData
				})
			})
				.then(response => {
					switch (response.status) {
						case 200:
							return response.json()
						case 400:
							return {
								error: i18n.error.thanksContactSupport
							}
						case 403:
							return {
								error: i18n.error.notAllowToConnect
							}
						case 404:
							return {
								error: i18n.error.notRegister
							}
						default:
							return undefined
					}
				})
				.then((json) => {
					if (json) {
						if (!json.error) {
							dispatch(SignInAction.login(resultData.login, resultData.password))
						} else {
							dispatch(resetPasswordAction.addMessage(json.error))
							dispatch(resetPasswordAction.setError())
						}
					}
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},

	addMessage(value) {
		return {
			type: ADD_MESSAGE,
			message: value
		}
	},
	setError() {
		return {
			type: ERROR
		}
	},
	resetMessage() {
		return {
			type: RESET_MESSAGE
		}
	}
}
export default resetPasswordAction



// WEBPACK FOOTER //
// ./src/resetPassword/actions/resetPasswordAction.js